import React, { Component, Fragment } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import Button from '../../UniformComponents/Button'
import Select from '../form/Select'

const currencyOptions = [
    { label: 'USD', value: 'USD' },
    { label: 'GBP', value: 'GBP' },
    { label: 'EUR', value: 'EUR' },
    { label: 'AUD', value: 'AUD' },
]

@observer
class DataExplorerHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menuOpen: false,
        }
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.toggleMenuOpen)
    }

    toggleMenuOpen = () => {
        const { menuOpen } = this.state
        if (!menuOpen) document.body.addEventListener('click', this.toggleMenuOpen)
        if (menuOpen) document.body.removeEventListener('click', this.toggleMenuOpen)
        this.setState((prevState) => ({ menuOpen: !prevState.menuOpen }))
    }

    renderMenu = () => {
        const { menuOpen } = this.state
        return (
            <div className="menu" style={{ marginRight: '20px', cursor: 'pointer', position: 'relative' }}>
                <div
                    onClick={this.toggleMenuOpen}
                    style={{
                        border: '1px solid #EDF1F7',
                        height: '32px',
                        width: '32px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '4px',
                        backgroundColor: menuOpen ? '#EDF1F7' : undefined,
                    }}
                >
                    <i className="fa-solid fa-ellipsis-vertical" style={{ fontSize: '14px' }} />
                </div>
                <div style={{
                    position: 'absolute',
                    width: '228px',
                    height: '200px',
                    top: '35px',
                    left: '-168px',
                    display: menuOpen ? 'block' : 'none',
                    background: 'white',
                    boxShadow: '2px 2px 26px #102E4A26',
                    borderRadius: '6px',
                    cursor: 'default',
                    zIndex: '5000',
                }}
                >
                    <ul style={{
                        listStyleType: 'none', fontSize: '13px', cursor: 'pointer', height: '100%', position: 'relative',
                    }}
                    >
                        <li style={{ padding: '10px 0 10px 32px' }}>
                            <i className="fa-light fa-pen-to-square" style={{ marginRight: '5px' }} />
                            {i18n.t('dataExplorer.menu.rename')}
                        </li>
                        <li style={{ padding: '10px 0 10px 32px' }}>
                            <i className="fa-light fa-clone" style={{ marginRight: '5px' }} />
                            {i18n.t('dataExplorer.menu.duplicate')}
                        </li>
                        <li style={{ padding: '10px 0 10px 32px' }}>
                            <i className="fa-regular fa-file-export" style={{ marginRight: '5px' }} />
                            {i18n.t('dataExplorer.menu.export')}
                        </li>
                        <li style={{ padding: '10px 0 10px 32px' }}>
                            <i className="fa-regular fa-circle-plus" style={{ marginRight: '5px' }} />
                            {i18n.t('dataExplorer.menu.create')}
                        </li>
                        <li
                            style={{
                                padding: '10px 0 10px 32px', bottom: 0, position: 'absolute', color: '#D9314B', backgroundColor: '#FAFBFC', width: '100%',
                            }}
                            >
                            <i className="fas fa-times" style={{ marginRight: '5px' }} />
                            {i18n.t('delete')}
                        </li>
                    </ul>
                </div>
            </div>
        )
    }

    render() {
        const { DataExplorerStore } = this.props
        const {
            report,
            excelExport,
            reportData,
            showCurrency,
            changeCurrency,
            selectedCurrency,
        } = DataExplorerStore

        const showDataControls = reportData && reportData.length
        const { title } = report
        return (
            <div className="dataExplorerHeader">
                <div className="leftHeader">
                    <h2 className="title">{title}</h2>
                </div>
                <div className="actions">
                    {showDataControls
                        ? (
                            <Fragment>
                                {showCurrency
                                    ? (
                                        <div style={{ width: '90px' }}>
                                            <Select
                                                options={currencyOptions}
                                                onBlur={changeCurrency}
                                                defaultValue={selectedCurrency}
                                                classNamePrefix="z10 dropdown"
                                                className="exploriDropdown"
                                            />
                                        </div>
                                    )
                                    : null }

                                <Button
                                    onClick={excelExport}
                                    label={i18n.t('dataExplorer.menu.export')}
                                    icon="fa-sharp fa-regular fa-file-export"
                                    cssClass="primary regular"
                                />
                            </Fragment>
                        )
                        : null}
                </div>
            </div>
        )
    }
}

export default DataExplorerHeader
